export default __webpack_public_path__ + "static/media/logo.822b8712.svg";